import { expansionPanelItem }from './expansionPanel';


export const languagesDetailSectionItems: expansionPanelItem[] = [
  {
    title: 'PHP',
    content: '経験年数が一番多い言語です。'
  },
  {
    title: 'TypeScript',
    content: '直近の業務では、ReactやNuxtをTypeScriptで書くことが多いです。'
  },
  {
    title: 'JavaScript',
    content: ''
  },
  {
    title: 'Shell',
    content: ''
  },
  {
    title: 'Python',
    content: ''
  },
  {
    title: 'Java',
    content: '一番最初に業務で触れた言語で、オブジェクト思考の書籍を読む時は、Java本を読むことがあります。'
  },
  {
    title: 'Go',
    content: 'Web APIでは簡単なサンプルなどを作成した程度です。簡単な業務ツールをgoroutineで並列処理にして作成しました。'
  },
];
